function locationsByDocument(grp, recordName = "locations") {
  const locations = grp[recordName] || { order: [] };

  const result = {};

  locations.order.forEach((id) => {
    const location = locations[id];
    if (location) {
      if (!result[location.document_id]) {
        result[location.document_id] = [];
      }

      if (
        grp.documents?.[location.document_id]?.data?.pages?.[location.page_id]
      ) {
        result[location.document_id].push(location);
      }
    }
  });

  return result;
}

export default locationsByDocument;
